<app-action-form [item]="item" [slot]="slot" [form]="form">
	<div class="form-section app-margin-horizontal app-padding">
        <div class="form-group" [formGroup]="form">
            <app-unit-quantity label="Dose" unitLabel="mmol/L" placeholder="Value" inputMode="decimal" formControlName="dose"></app-unit-quantity>
        </div>
        <app-common-action-controls [action]="action" [form]="form"></app-common-action-controls>
      </div>
</app-action-form>